import StudentData from "../components/StudentData";
import Loading from "../components/Loading";
import { useState } from "react";

export default function StudentList({
  setSearch,
  search,
  students,
  loading,
  count,
}) {
  const user = JSON.parse(localStorage.getItem("profile")).value[0];
  const [localSearch, setLocalSearch] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(localSearch);
    setHasSearched(true);
  };

  return (
    <div className="flex flex-col items-center">
      {count && user.role !== "user" ? (
        <span
          className="mt-0 mb-5 p-3 w-14 h-14 flex items-center justify-center 
      rounded-full text-sm text-green-700 bg-green-100"
        >
          {students?.length}
        </span>
      ) : (
        ""
      )}
      <form className="flex justify-between" onSubmit={handleSearch}>
        <div>
          <input
            type="search"
            className="bg-white border-2 h-10 pr-5 pl-10 rounded-full text-sm 
                      outline-2 outline-blue-700"
            placeholder="Search by National ID, Passport, or Name..."
            onChange={(e) => setLocalSearch(e.target.value)}
            value={localSearch}
          />
          <button
            type="submit"
            className="ml-2 px-4 py-2 bg-blue-600 text-white rounded"
          >
            Search
          </button>
        </div>
      </form>
      {hasSearched ? (
        loading ? <Loading /> : <StudentData students={students} />
      ) : (
        <div className="text-gray-500 mt-8">Please enter a search term to view data or press search without entering any data to show all students in this state.</div>
      )}
    </div>
  );
}

